import { Link } from "react-router-dom";
import "../styles/Banner2.css";
import bouquetImg from "../assets/cc.png";

export default function CategoryBanner() {
    return (
        <div className="category-wrapper">

            {/* 🌸 FLOWER BOUQUET */}
            <div className="category-banner">

                <div className="banner-left">
                    <p className="small-title">CAPTURE MEMORIES</p>

                    <h2>Photo Frames</h2>

                    <p className="descc">
                        Turn your special moments into timeless keepsakes—<br />
                        beautifully crafted frames made with love.
                    </p>

                    {/* <Link to="/category/1780757668920" className="banner-shop-btn">
                        Shop Now
                    </Link> */}
                    <Link
                        to="/category/1780757668920"
                        state={{ categoryName: "Photo Frames" }}
                        className="banner-shop-btn"
                    >
                        Shop Now
                    </Link>
                </div>

                <div className="banner-right">
                    <img src={bouquetImg} alt="Bouquet" />
                </div>

            </div>

        </div>
    );
}